// extracted by mini-css-extract-plugin
module.exports =  {"faqSection":"FaqSectionComponent_faqSection__ZNVnP","gwSectionContainer":"FaqSectionComponent_gwSectionContainer__YyhNK"};